import * as React from 'react';
import PromoCode from '../../components/promo-code';
//import { AppProps } from '../../components/app';
import CalendarContainer from '../../components/calendar-container';
import FiltersContainer from '../../components/filters/container';
import CalendarViewToggle from '../../components/calendar-view-toggle';
import ScrollToTop from '../../components/navigation/scroll-to-top';
import { CalendarDeviceMode } from '../../classes/calendar';
import MonthSelectionDropdown from '../../components/month-selection/dropdown';

const AppView: React.StatelessComponent<any> = props => {
    return (
        <section className="ace-cal">
            <h1 className="visually-hidden">{props.text.calendarAppHeading}</h1>
            <section className="ace-cal-subnav ace-cal-subnav-mobile">
                <h2 className="visually-hidden">{props.text.calendarControlsHeading}</h2>
                <div className="ace-cal-subnav-triggers">
                    <button type="button" data-a11y-dialog-show="filters-dialog" aria-label={props.text.filterOpenButtonLabel} className="ace-cal-filter-modal-trigger btn btn-icon-left">
                        <svg focusable="false" className="svg-icon" aria-hidden="true">
                            <use xlinkHref="#icon-filter" />
                        </svg>
                        {props.text.openFiltersButtonText}
                    </button>
                    <button type="button" data-a11y-dialog-show="promo-code-dialog" aria-label={props.text.promoCodeDescriptionText} className="ace-cal-promo-modal-trigger un-button primary-link">
                        {props.text.promoCodeDescriptionText}
                    </button>
                </div>
                <div className="ace-cal-subnav-month">
                    <MonthSelectionDropdown />
                </div>
            </section>
            <nav className="ace-cal-filters-container ace-filters-container">
                <h2 className="visually-hidden">{props.text.calendarFiltersHeading}</h2>
                <FiltersContainer />
                {
                    props.calendarDeviceMode === CalendarDeviceMode.MOBILE &&
                    <div className="ace-cal-modal-wrapper">
                        <PromoCode />
                    </div>
                }
            </nav>
            {
                props.calendarDeviceMode === CalendarDeviceMode.DESKTOP &&
                <section className="ace-cal-subnav">
                    <h2 className="visually-hidden">{props.text.calendarControlsHeading}</h2>
                    <PromoCode />
                    <CalendarViewToggle />
                </section>
            }
            <CalendarContainer />
            <ScrollToTop />
        </section>
    );
}

export default AppView;